import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';
import { useDataStore } from '@/store/data';
import { PendingInvite } from '@/types';
import { useWallet } from 'solana-wallets-vue';

const getData = async (): Promise<PendingInvite[]> => {
  const dataStore = useDataStore();
  const { publicKey } = useWallet();

  const data: PendingInvite[] = [];
  if (!publicKey.value) return data;

  // Todo: Parrallelize requests
  const pendings = await axios.get(
    `https://invite-api.jup.ag/get/pending-invites/${publicKey.value.toString()}`,
  );

  const claimed = await axios.get(
    `https://invite-api.jup.ag/get/invite-history/${publicKey.value.toString()}`,
  );

  data.push(
    ...pendings.data.map((pending: PendingInvite) => ({
      ...pending,
      code: dataStore.getInviteCode(pending.invite_pda),
    })),
  );
  data.push(...claimed.data);

  // Todo: Sort by creation time
  data.sort((a, b) => {
    return (
      new Date(Number(b.creation_time) * 1000).getTime() -
      new Date(Number(a.creation_time) * 1000).getTime()
    );
  });

  return data;
};

export default function usePendings() {
  return useQuery({
    queryKey: ['pendings'],
    queryFn: getData,
    staleTime: 1000 * 60 * 60 * 24,
  });
}
